import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DialogData } from 'src/app/models/dialog-data';
import { DialogComponent } from 'src/app/components/dialog/dialog.component';
import { BeBanco } from 'src/app/models/BeBanco';
import { SubService } from 'src/app/services/sub.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { ListaDadosColuna } from 'src/app/components/lista-dados/lista-dados.component';

@Component({
  selector: 'app-bancos',
  templateUrl: './list-bancos.component.html',
  styleUrls: ['./list-bancos.component.css']
})
export class ListBancosComponent implements OnInit, OnDestroy {
  public bancos: BeBanco[] = [];
  public colunasListaDados: ListaDadosColuna[] = [
    {
      campo: 'noBanco',
      rotulo: 'Banco',
      tamanho: '60%',
      editavel: true,
      edicao: {
        tipoEditor: 'texto',
        validacao: {
          obrigatorio: true,
          minLength: 3,
          maxLength: 100,
        }
      }
    }
  ];
  public subscription?: Subscription;

  public constructor(
    private httpClient: HttpClient,
    private sub: SubService,
    private dialog: MatDialog,
    private snackBarService: SnackBarService,
  ) {}

  public ngOnInit(): void {
    this.subscription = this.httpClient.get<BeBanco[]>(
      `/api/Bancos`
    ).subscribe({
      next: (res) => {
        this.unsubscribe();
        this.bancos = res ?? [];
      },
      error: (err) => {
        this.unsubscribe();
        this.snackBarService.exibirErro(`Erro! - ${err.status} - ${err.statusText}`);
      }
    });
  }

  public ngOnDestroy(): void {
    this.unsubscribe();
  }

  public onSalvarLinha(banco: BeBanco) {
    this.unsubscribe();

    const payload: any = {
      idBanco: banco.idBanco ?? null,
      noBanco: (banco.noBanco ?? '').trim(),
    };

    const requisicao = payload.idBanco
      ? this.httpClient.put<unknown>(`/api/Bancos`, payload)
      : this.httpClient.post<BeBanco>(`/api/Bancos`, payload);

    this.subscription = requisicao.subscribe({
      next: (res: any) => {
        this.unsubscribe();
        if (!payload.idBanco && res?.idBanco) {
          banco.idBanco = res.idBanco;
        }
        banco.noBanco = payload.noBanco;
        this.bancos = [...this.bancos];
        this.snackBarService.exibirSucesso(payload.idBanco ? 'Registro salvo!' : 'Registro criado!');
      },
      error: (err) => {
        this.unsubscribe();
        this.snackBarService.exibirErro(`Erro! - ${err.status} - ${err.statusText}`);
      }
    });
  }

  public onDelete(banco: BeBanco) {
    this.showDialog('Deseja excluir esse registro?', 'Alerta', 'Não', 'Sim', banco);
  }

  public showDialog(msg: string, statusMsg: string, button: string = 'OK', secondButton: string = '', banco: BeBanco = {} as BeBanco) {
    if (this.subscription)
      return;
    const dialogData: DialogData = {
      title: statusMsg,
      message: msg,
      buttonText: button,
      secondButtonText: secondButton,
    };
    const dialogRef = this.dialog.open(DialogComponent, { data: dialogData });
    dialogRef.afterClosed().subscribe((result) => {
      this.unsubscribe();
      if (result) {
        this.sub.reset(this.httpClient.delete(`/api/Bancos/${banco.idBanco}`),
          () => this.onDeleteConfirm(banco),
          () => this.showDialog('Não foi possível excluir o registro!', 'Erro')
        );
      }
    })
  }

  private onDeleteConfirm(res: BeBanco) {
    this.bancos = this.bancos.filter(banco => banco.idBanco !== res.idBanco);
    this.snackBarService.exibirSucesso('Registro excluído!');
  }

  private unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = undefined;
    }
  }
}
